define([
	"src/c8-platform/service/languageService",
], function(languageService) {

	const { clearPinyinCache, enablePinyin, getPinyin, isPinyinEnabled} = languageService;

	/**
	 * Check if user is using Chinese version
	 * @param {string} locale
	 * @return {boolean}
	 */
	function isChineseLocale(locale) {
		var locales = ["zh", "zh_TW"];
		return locales.indexOf(locale) > -1;
	}

	/**
	 * Trim the extra symbol which added by the input source tools(for now, the input source tool refers to 'Sogou')
	 * @param {string} qs
	 * @return {string}
	 */
	function trimExtraSymbol(qs) {
		// Input source tool('Sougou') will add ' between the letters, Maybe contains other characters in the future depending on the input source tool the user uses
		return qs.replace(/'/g, "");
	}

	/**
	 * Check if the query contains the Chinese character
	 * @param {string} value
	 * @return {boolean}
	 */
	function containsChinese(value) {
		//Represents the chinese
		var chinesePattern = /[\u4e00-\u9fa5]/;
		return chinesePattern.test(value);
	}

	return {
		clearPinyinCache,
		containsChinese,
		enablePinyin,
		getPinyin,
		isChineseLocale,
		isPinyinEnabled,
		trimExtraSymbol,
	};
});